exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".barcode-scanner-container[data-v-1a5703bd]{position:relative;height:90vh}.settings-container .settings-item[data-v-1a5703bd]{display:inline-block;padding-right:10px}.settings-container .settings-item label[data-v-1a5703bd]{display:inline}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1a5703bd","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./EcomCore/Components/InputDevices/ScanditBarcodeReader.vue
// module id = 62
// module chunks = 0